export default __webpack_public_path__ + "static/media/desktop_banner_travel.96ac787d.jpg";